/* ============================================================================
   LAH — MEMORIA DAS IMAGENS DO CONFIGURADOR
   Tema: Testes de implementacao (4.0)

   Faz duas coisas, e a primeira e a que resolve o travamento:

     1. PEDE AS IMAGENS NO TAMANHO CERTO ao servidor da Shopify.
     2. DESCARREGA as imagens das etapas fora de vista.

   ============================================================================
   1. O TAMANHO PEDIDO — a causa real
   ============================================================================
   As imagens das opcoes estao em 4500x4500 pixels. Esse numero nao tem relacao
   com o peso do arquivo: descompactada na memoria, uma imagem de 4500x4500
   ocupa cerca de 81 MB, seja ela um PNG de 3 MB ou de 15 MB.

   Tres opcoes na etapa de campo de visao passam de 240 MB. Um iPhone X tem
   pouco mais de 1 GB por aba — e ainda precisa do tema, dos apps e do proprio
   configurador.

   O sintoma que voce descreveu e a consequencia direta: o Safari descarta as
   imagens decodificadas para liberar espaco e precisa REFAZER o trabalho
   quando elas voltam a tela. Dai o atraso ao subir de volta — e, quando o
   ciclo se repete rapido demais, a aba morre.

   A CORRECAO nao toca em nenhum arquivo do admin. O servidor da Shopify
   entrega qualquer imagem redimensionada mediante um parametro na URL;
   pedimos 700 pixels, que e mais do que o dobro do espaco que a imagem ocupa
   na tela do celular.

   De 81 MB para cerca de 2 MB por imagem. E a mesma imagem, no mesmo lugar —
   so deixamos de baixar e decodificar 40 vezes mais pixels do que da para ver.

   POR QUE ISSO NAO ESTAVA RESOLVIDO: o configurador monta as imagens a partir
   dos metaobjetos sem pedir tamanho, e corrigir na origem significaria editar
   um arquivo de 36 KB no coracao do fluxo de compra. Reescrever a URL depois
   de pronta chega ao mesmo resultado sem esse risco.

   ============================================================================
   2. A DESCARGA DAS ETAPAS FORA DE VISTA
   ============================================================================
   Complementa a primeira: mesmo reduzidas, imagens de etapas que o cliente nao
   esta vendo nao precisam ocupar memoria. GIF animado e o caso extremo — ele
   guarda CADA QUADRO decodificado, e esconder o elemento nao libera nada.

   A etapa visivel e a seguinte ficam carregadas; a seguinte por antecipacao,
   para nao haver espera no proximo clique.
   ============================================================================ */

(function () {
    'use strict';

    /* No desktop ha memoria de sobra, e a tela e maior: manter a resolucao
       cheia ali nao custa e evita imagem borrada em monitor grande. */
    if (window.matchMedia('(min-width: 1000px)').matches) return;

    var raiz = document.querySelector('.product-lens-select');
    if (!raiz) return;

    /* 700px cobre com folga o maior espaco que essas imagens ocupam num
       celular, inclusive em tela de alta densidade. */
    var LARGURA = 700;

    var GUARDA = 'data-lah-src';
    var REDUZIDA = 'data-lah-reduzida';

    var VAZIO = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

    /* ---------------------------------------------------------------------
       1. TAMANHO PEDIDO
       --------------------------------------------------------------------- */
    function reduzirUrl(url) {
        if (!url) return url;
        if (url.indexOf('cdn.shopify.com') === -1) return url;
        if (url.indexOf('width=') !== -1) return url;

        return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + LARGURA;
    }

    function reduzir(img) {
        if (img.getAttribute(REDUZIDA)) return;

        var src = img.getAttribute('src');
        if (!src || src === VAZIO) return;

        var novo = reduzirUrl(src);

        img.setAttribute(REDUZIDA, '1');

        /* O srcset, se existir, tem prioridade sobre o src — reduzir so o src
           deixaria o navegador escolher a versao gigante mesmo assim. */
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');

        if (novo !== src) img.setAttribute('src', novo);
    }

    /* ---------------------------------------------------------------------
       2. DESCARGA FORA DE VISTA
       --------------------------------------------------------------------- */
    function descarregar(img) {
        if (img.getAttribute(GUARDA)) return;

        var src = img.getAttribute('src');
        if (!src || src === VAZIO) return;

        img.setAttribute(GUARDA, src);
        img.setAttribute('src', VAZIO);
    }

    function recarregar(img) {
        var src = img.getAttribute(GUARDA);
        if (!src) return;

        img.setAttribute('src', src);
        img.removeAttribute(GUARDA);
    }

    function visivel(etapa) {
        return etapa.offsetParent !== null;
    }

    var pendente = false;

    function aplicar() {
        pendente = false;

        var etapas = raiz.querySelectorAll('.product-lens-select-step');
        if (!etapas.length) return;

        var atual = -1;

        for (var i = 0; i < etapas.length; i++) {
            if (visivel(etapas[i])) { atual = i; break; }
        }

        for (var j = 0; j < etapas.length; j++) {
            var manter = (atual === -1) || (j === atual) || (j === atual + 1);
            var imgs = etapas[j].querySelectorAll('img');

            for (var k = 0; k < imgs.length; k++) {
                /* A reducao vem sempre antes: assim a imagem que voltar ja
                   volta no tamanho certo. */
                reduzir(imgs[k]);

                if (manter) {
                    recarregar(imgs[k]);
                } else {
                    descarregar(imgs[k]);
                }
            }
        }
    }

    function agendar() {
        if (pendente) return;
        pendente = true;
        requestAnimationFrame(aplicar);
    }

    /* Primeira passada cedo: quanto antes as imagens forem reduzidas, menos
       vezes o navegador decodifica a versao gigante. */
    aplicar();
    setTimeout(aplicar, 400);
    setTimeout(aplicar, 1500);

    /* Cada avanco de etapa muda quem esta visivel. Observamos so entrada e
       saida de elementos — atributos criariam laco com as nossas escritas. */
    if (window.MutationObserver) {
        new MutationObserver(agendar).observe(raiz, {
            childList: true,
            subtree: true
        });
    }

    document.addEventListener('click', function (event) {
        if (!event.target.closest) return;
        if (!event.target.closest('.product-lens-select-item, .lens-footer-button, .openProductLens')) return;

        setTimeout(agendar, 120);
    }, true);
})();
